export enum ChargebeeSubscriptionPlanId {
  STANDARD_INDIVIDUAL_MONTHLY = 'MyAxelos-Standard-Individual-Sub-GBP-Monthly',
  STANDARD_INDIVIDUAL_YEARLY = 'MyAxelos-Standard-Individual-Sub-GBP-Yearly',
  STANDARD_INDIVIDUAL_MONTHLY_MIGRATION = 'MyAxelos-Standard-Individual-Sub-Mig-GBP-Monthly',
  STANDARD_INDIVIDUAL_YEARLY_MIGRATION = 'MyAxelos-Standard-Individual-Sub-Mig-GBP-Yearly',
  STANDARD_INDIVIDUAL_MONTHLY_3MF = 'MyAxelos-Standard-Individual-Sub-3MF-GBP-Monthly',
  STANDARD_INDIVIDUAL_YEARLY_3MF = 'MyAxelos-Standard-Individual-Sub-3MF-GBP-Yearly',
}
